<script setup lang="ts">
  import { computed } from "vue";
  import { useToday } from "./utils";
  import { default as MoneymapFilterRangeModal } from "./MoneymapFilterRangeModal.vue";

  const { selected_range_id } = defineProps<{ selected_range_id: string }>();
  const emit = defineEmits<{ (e: "change", id: string): void }>();

  const today = useToday();
  const list = computed(() => today.value.ids.map((id) => today.value.map[id]));
</script>

<template>
  <MoneymapFilterRangeModal :selected_range_id="selected_range_id" :items="list" @click:item="emit('change', $event)" />
</template>
